import { Link } from "@bcm-dev/bcms-vite";
import "./styles.css";

export default function PageNotFound() {
    return(
        <div className="PageNotFound">
            <h1 className="text-center">Page Not Found</h1>
            <Link className="primary text-center" to="/paybills">Return to Home</Link>
        </div>
    )
}
